import { createContext, type PropsWithChildren, useContext, useState } from 'react'
import { useMenuOutboundLayoutContext } from 'widgets/Menu/ui/MenuOutbound'
import { ReviewsPageStore } from 'pages/reviews/store/reviewsPageStore'

export const ReviewsPageContext = createContext<ReviewsPageStore | null>(null)

export const useReviewsPageContext = () => {
  const context = useContext(ReviewsPageContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with ReviewsPageContext')

  return context
}

export const ReviewsPageProvider = ({ children }: PropsWithChildren) => {
  const menuLayoutStore = useMenuOutboundLayoutContext()
  const [store] = useState(() => new ReviewsPageStore(menuLayoutStore.pageLayoutStore))

  return <ReviewsPageContext.Provider value={store}>{children}</ReviewsPageContext.Provider>
}
